export const getFuelVolumeUnit = (source) => {
  if (!source) return null;
  if (typeof source === 'string') return source;
  if (source.code || source.name || source.conversion_rate_to_litre !== undefined) return source;
  return source.fuel_volume_unit || source.volume_unit || source.unit || null;
};

export const hasConfiguredFuelVolumeUnit = (source) => Boolean(getFuelVolumeUnit(source));

export const getFuelVolumeUnitLabel = (source) => {
  const unit = getFuelVolumeUnit(source);
  if (!unit) return 'Litres';
  if (typeof unit === 'string') return unit;
  return unit.name || unit.code || 'Configured Unit';
};

export const getFuelVolumeUnitShortLabel = (source) => {
  const unit = getFuelVolumeUnit(source);
  if (!unit) return 'L';
  const unitText = typeof unit === 'string'
    ? unit
    : `${unit.code || ''} ${unit.name || ''} ${unit.label || ''}`;
  if (unitText.toLowerCase().includes('gallon')) return 'gallons';
  if (typeof unit === 'string') return unit;
  return unit.name || unit.code || 'Unit';
};

const isLitresUnit = (source) => {
  const unit = getFuelVolumeUnit(source);
  if (!unit) return false;

  const unitText = typeof unit === 'string'
    ? unit
    : `${unit.code || ''} ${unit.name || ''} ${unit.label || ''}`;
  const normalizedUnitText = unitText.trim().toLowerCase();

  if (['l', 'liter', 'liters', 'litre', 'litres'].includes(normalizedUnitText)) return true;

  const conversionRate = Number(unit?.conversion_rate_to_litre);
  return Number.isFinite(conversionRate) && conversionRate === 1;
};

export const litresToConfiguredUnit = (litres, source) => {
  const unit = getFuelVolumeUnit(source);
  const rate = Number(unit?.conversion_rate_to_litre);
  const value = Number(litres);
  if (!unit || !Number.isFinite(value) || !Number.isFinite(rate) || rate <= 0) return null;
  return value / rate;
};

export const formatVolumeValue = (litres, configuredValue, source) => {
  const litreValue = Number(litres);
  if (!Number.isFinite(litreValue)) return '0 L';

  const litreText = litreValue ? `${litreValue.toFixed(2)} L` : '0 L';
  const hasConfiguredUnit = hasConfiguredFuelVolumeUnit(source);
  if (!hasConfiguredUnit || isLitresUnit(source)) return litreText;

  let configuredNumber = Number(configuredValue);
  if (!Number.isFinite(configuredNumber)) {
    configuredNumber = litresToConfiguredUnit(litreValue, source);
  }
  if (!Number.isFinite(configuredNumber)) return litreText;

  const configuredLabel = getFuelVolumeUnitShortLabel(source);
  return `${litreText} (${configuredNumber.toFixed(2)} ${configuredLabel})`;
};
